const videos = [
  {
    id: 1,
    title: "Los Secretos de la ciudad prohibida",
    url: "https://www.youtube.com/embed/hL3uwaPteyQ", // URL embed de YouTube
    description: "Descubre la historia y misterios tras los muros rojos",
    thumbnail: "https://img.youtube.com/vi/hL3uwaPteyQ/hqdefault.jpg", // thumbnail de YouTube
  },
  {
    id: 2,
    title: "Beijing: La Ciudad Prohibida",
    url: "https://www.youtube.com/embed/f-jTdtL9L1E",
    description: "Disfruta de la belleza de la ciudad prohibida",
    thumbnail: "https://img.youtube.com/vi/f-jTdtL9L1E/hqdefault.jpg",
  },
  {
    id: 3,
    title: "Espectáculo de Acrobacia Pekinesa",
    url: "https://www.youtube.com/embed/g9jegbi18Jg",
    description: "Disfruta del mejor show en Teatro Rojo",
    thumbnail: "https://img.youtube.com/vi/g9jegbi18Jg/hqdefault.jpg",
  },
];

export default videos;
